import React, { useState, useEffect, useCallback } from 'react';
import {
    FaBox, FaPlus, FaEdit, FaTrash, FaTimes, FaSave, FaChartLine, FaWarehouse,
    FaArrowUp, FaArrowDown, FaExclamationTriangle, FaCalendarDay, FaCalendarAlt,
    FaFileAlt, FaPrint, FaDownload, FaBan
} from 'react-icons/fa';
import Loader from './Loader';
import { useT } from '../i18n/LanguageContext';

const T = {
    en: {
        operationFailed: 'Operation failed',
        confirmDeleteProduct: 'Are you sure you want to delete this product?',
        failedDeleteProduct: 'Failed to delete product',
        failedGenerateReport: 'Failed to generate report',
        failedAdjustStock: 'Failed to adjust stock',
        csvDailyTitle: 'ElecSolution Stock Inventory — Daily Report',
        csvMonthlyTitle: 'ElecSolution Stock Inventory — Monthly Report',
        csvDate: 'Date',
        csvYear: 'Year',
        csvMonth: 'Month',
        csvGenerated: 'Generated',
        csvSummary: 'Summary',
        csvTotalMovements: 'Total Movements',
        csvUnitsIn: 'Units In',
        csvUnitsOut: 'Units Out',
        csvNetUnits: 'Net Units',
        csvValueIn: 'Value In (XAF)',
        csvValueOut: 'Value Out (XAF)',
        csvNetValue: 'Net Value (XAF)',
        csvSales: 'Sales',
        csvRestocks: 'Restocks',
        csvAdjustments: 'Adjustments',
        csvTopProducts: 'Top Products',
        csvNumber: '#',
        csvProduct: 'Product',
        csvCategory: 'Category',
        csvUnitPrice: 'Unit Price (XAF)',
        csvUnitsSold: 'Units Sold',
        csvValueSold: 'Value Sold (XAF)',
        csvUnitsAdded: 'Units Added',
        csvValueAdded: 'Value Added (XAF)',
        csvTotals: 'Totals',
        csvMovements: 'Movements',
        csvTime: 'Time',
        csvType: 'Type',
        csvChange: 'Change',
        csvLineValue: 'Line Value (XAF)',
        csvStockAfter: 'Stock After',
        csvNote: 'Note',
        csvBy: 'By',
        csvDailyBreakdown: 'Daily Breakdown',
        csvDay: 'Day',
        csvMonthTotals: 'Month Totals',
        system: 'System',
        stockInventory: 'Stock Inventory',
        restockAdjust: 'Restock / Adjust',
        loadingInventory: 'Loading inventory',
        skus: 'SKUs',
        unitsInStock: 'Units in Stock',
        inventoryValue: 'Inventory Value',
        lowStockLabel: 'Low Stock (< 10)',
        outOfStock: 'Out of Stock',
        today: 'Today',
        thisMonth: 'This Month',
        inSuffix: 'in',
        outSuffix: 'out',
        movements: 'movements',
        dailyActivity: 'Daily Activity',
        monthlyActivity: 'Monthly Activity',
        reports: 'Reports',
        stockAvailable: 'Stock Available',
        dateLabel: 'Date:',
        monthLabel: 'Month:',
        unitsInPill: 'units in',
        unitsOutPill: 'units out',
        salesPill: 'sales',
        restocksPill: 'restocks',
        adjustmentsPill: 'adjustments',
        topProductsOn: (date) => `Top Products on ${date}`,
        product: 'Product',
        unitsSold: 'Units Sold',
        unitsAdded: 'Units Added',
        allMovements: 'All Movements',
        time: 'Time',
        type: 'Type',
        change: 'Change',
        currentStock: 'Current Stock',
        note: 'Note',
        by: 'By',
        noStockActivityDay: 'No stock activity on this day.',
        dailyBreakdown: 'Daily Breakdown',
        day: 'Day',
        unitsInCol: 'Units In',
        unitsOutCol: 'Units Out',
        movementsCol: 'Movements',
        net: 'Net',
        noStockActivityMonth: 'No stock activity this month.',
        topProductsThisMonth: 'Top Products This Month',
        category: 'Category',
        dailyReport: 'Daily Report',
        monthlyReport: 'Monthly Report',
        generating: 'Generating',
        generatingReport: 'Generating report',
        generateReport: 'Generate Report',
        print: 'Print',
        downloadCsv: 'Download CSV',
        reportSubtitleDaily: 'Stock Inventory — Daily Report',
        reportSubtitleMonthly: 'Stock Inventory — Monthly Report',
        dateColon: 'Date:',
        periodColon: 'Period:',
        generatedColon: 'Generated:',
        byColon: 'By:',
        totalMovements: 'Total Movements',
        unitsIn: 'Units In',
        unitsOut: 'Units Out',
        sales: 'Sales',
        restocks: 'Restocks',
        adjustments: 'Adjustments',
        netUnits: 'Net Units',
        valueIn: 'Value In',
        valueOutSales: 'Value Out (Sales)',
        netValue: 'Net Value',
        topProductsOfDay: 'Top Products of the Day',
        unitPrice: 'Unit Price',
        valueSold: 'Value Sold',
        valueAdded: 'Value Added',
        totals: 'Totals',
        noProductActivityDate: 'No product activity on this date.',
        allStockMovements: 'All Stock Movements',
        lineValue: 'Line Value',
        stockAfter: 'Stock After',
        dayTotals: 'Day Totals',
        noMovementsDate: 'No movements recorded on this date.',
        netUnitsCol: 'Net Units',
        valueInCol: 'Value In',
        valueOutCol: 'Value Out',
        netValueCol: 'Net Value',
        monthTotals: 'Month Totals',
        noActivityMonth: 'No activity recorded this month.',
        topProductsOfMonth: 'Top Products of the Month',
        totalsTop: (n) => `Totals (top ${n})`,
        noTopProductsData: 'No top products data.',
        reportFooterTitle: 'ElecSolution — Stock Inventory Report',
        reportFooterPage: 'Generated automatically by the admin panel',
        pickDateOrMonth: 'Pick a date or month above and click',
        addProduct: 'Add Product',
        skusPill: 'SKUs',
        unitsPill: 'units',
        totalValuePill: 'XAF total value',
        designation: "DESCRIPTION",
        categoryCol: "CATEGORY",
        entryDateCol: "ENTRY DATE",
        qty: "QTY",
        unitPriceCol: 'UNIT PRICE',
        total: 'TOTAL',
        actions: 'ACTIONS',
        restockTitle: 'Restock',
        editProductTitle: 'Edit product',
        deleteProductTitle: 'Delete product',
        totalStockValue: 'TOTAL STOCK VALUE',
        noProductsYet: 'No products in stock yet. Click',
        toCreateOne: 'to create one.',
        loadingStockAvailable: 'Loading stock available',
        editStockEntry: 'Edit Stock Entry',
        addStockEntry: 'Add Stock Entry',
        designationLabel: 'Description *',
        designationPlaceholder: 'e.g. Butterfly Case',
        categoryLabel: 'Category *',
        selectCategory: '-- Select category --',
        newCategoryOption: '+ New category…',
        newCategoryPlaceholder: 'New category name',
        entryDateLabel: 'Entry date *',
        qtyLabel: 'Qty *',
        unitPriceLabel: 'Unit price (XAF) *',
        totalAutoLabel: 'Total (auto)',
        saveChanges: 'Save Changes',
        lowStockAlert: 'Low Stock Alert',
        stock: 'Stock',
        price: 'Price',
        quickRestock: 'Quick Restock',
        restock: 'Restock',
        restockAdjustStock: 'Restock / Adjust Stock',
        productLabel: 'Product *',
        searchProductsPlaceholder: 'Search products by name, category, or ID…',
        clear: 'Clear',
        noProductsMatch: 'No products match',
        stockColon: (n) => `stock: ${n}`,
        typeLabel: 'Type *',
        restockAddOption: 'Restock (add)',
        adjustmentOption: 'Adjustment (+ or -)',
        quantityLabel: 'Quantity *',
        useNegativeToRemove: '(use negative to remove)',
        restockQtyPlaceholder: 'e.g. 50',
        adjustQtyPlaceholder: 'e.g. -3',
        noteLabel: 'Note',
        notePlaceholder: 'Reason for adjustment (optional)',
        saveMovement: 'Save Movement',
        stockSelected: (name, category, qty) => `${name} — ${category} (stock: ${qty})`,
    },
    fr: {
        operationFailed: "L'opération a échoué",
        confirmDeleteProduct: "Voulez-vous vraiment supprimer ce produit ?",
        failedDeleteProduct: "Échec de la suppression du produit",
        failedGenerateReport: "Échec de la génération du rapport",
        failedAdjustStock: "Échec de l'ajustement du stock",
        csvDailyTitle: "ElecSolution Inventaire du stock — Rapport journalier",
        csvMonthlyTitle: "ElecSolution Inventaire du stock — Rapport mensuel",
        csvDate: "Date",
        csvYear: "Année",
        csvMonth: "Mois",
        csvGenerated: "Généré le",
        csvSummary: "Résumé",
        csvTotalMovements: "Total des mouvements",
        csvUnitsIn: "Unités entrées",
        csvUnitsOut: "Unités sorties",
        csvNetUnits: "Unités nettes",
        csvValueIn: "Valeur entrée (XAF)",
        csvValueOut: "Valeur sortie (XAF)",
        csvNetValue: "Valeur nette (XAF)",
        csvSales: "Ventes",
        csvRestocks: "Réapprovisionnements",
        csvAdjustments: "Ajustements",
        csvTopProducts: "Meilleurs produits",
        csvNumber: "#",
        csvProduct: "Produit",
        csvCategory: "Catégorie",
        csvUnitPrice: "Prix unitaire (XAF)",
        csvUnitsSold: "Unités vendues",
        csvValueSold: "Valeur vendue (XAF)",
        csvUnitsAdded: "Unités ajoutées",
        csvValueAdded: "Valeur ajoutée (XAF)",
        csvTotals: "Totaux",
        csvMovements: "Mouvements",
        csvTime: "Heure",
        csvType: "Type",
        csvChange: "Variation",
        csvLineValue: "Valeur de ligne (XAF)",
        csvStockAfter: "Stock après",
        csvNote: "Note",
        csvBy: "Par",
        csvDailyBreakdown: "Détail journalier",
        csvDay: "Jour",
        csvMonthTotals: "Totaux du mois",
        system: "Système",
        stockInventory: "Inventaire du stock",
        restockAdjust: "Réapprovisionner / Ajuster",
        loadingInventory: "Chargement de l'inventaire",
        skus: "Références",
        unitsInStock: "Unités en stock",
        inventoryValue: "Valeur de l'inventaire",
        lowStockLabel: "Stock faible (< 10)",
        outOfStock: "En rupture de stock",
        today: "Aujourd'hui",
        thisMonth: "Ce mois-ci",
        inSuffix: "entrées",
        outSuffix: "sorties",
        movements: "mouvements",
        dailyActivity: "Activité journalière",
        monthlyActivity: "Activité mensuelle",
        reports: "Rapports",
        stockAvailable: "Stock disponible",
        dateLabel: "Date :",
        monthLabel: "Mois :",
        unitsInPill: "unités entrées",
        unitsOutPill: "unités sorties",
        salesPill: "ventes",
        restocksPill: "réapprovisionnements",
        adjustmentsPill: "ajustements",
        topProductsOn: (date) => `Meilleurs produits le ${date}`,
        product: "Produit",
        unitsSold: "Unités vendues",
        unitsAdded: "Unités ajoutées",
        allMovements: "Tous les mouvements",
        time: "Heure",
        type: "Type",
        change: "Variation",
        currentStock: "Stock actuel",
        note: "Note",
        by: "Par",
        noStockActivityDay: "Aucune activité de stock ce jour.",
        dailyBreakdown: "Détail journalier",
        day: "Jour",
        unitsInCol: "Unités entrées",
        unitsOutCol: "Unités sorties",
        movementsCol: "Mouvements",
        net: "Net",
        noStockActivityMonth: "Aucune activité de stock ce mois-ci.",
        topProductsThisMonth: "Meilleurs produits ce mois-ci",
        category: "Catégorie",
        dailyReport: "Rapport journalier",
        monthlyReport: "Rapport mensuel",
        generating: "Génération en cours",
        generatingReport: "Génération du rapport",
        generateReport: "Générer le rapport",
        print: "Imprimer",
        downloadCsv: "Télécharger le CSV",
        reportSubtitleDaily: "Inventaire du stock — Rapport journalier",
        reportSubtitleMonthly: "Inventaire du stock — Rapport mensuel",
        dateColon: "Date :",
        periodColon: "Période :",
        generatedColon: "Généré le :",
        byColon: "Par :",
        totalMovements: "Total des mouvements",
        unitsIn: "Unités entrées",
        unitsOut: "Unités sorties",
        sales: "Ventes",
        restocks: "Réapprovisionnements",
        adjustments: "Ajustements",
        netUnits: "Unités nettes",
        valueIn: "Valeur entrée",
        valueOutSales: "Valeur sortie (Ventes)",
        netValue: "Valeur nette",
        topProductsOfDay: "Meilleurs produits du jour",
        unitPrice: "Prix unitaire",
        valueSold: "Valeur vendue",
        valueAdded: "Valeur ajoutée",
        totals: "Totaux",
        noProductActivityDate: "Aucune activité produit à cette date.",
        allStockMovements: "Tous les mouvements de stock",
        lineValue: "Valeur de ligne",
        stockAfter: "Stock après",
        dayTotals: "Totaux du jour",
        noMovementsDate: "Aucun mouvement enregistré à cette date.",
        netUnitsCol: "Unités nettes",
        valueInCol: "Valeur entrée",
        valueOutCol: "Valeur sortie",
        netValueCol: "Valeur nette",
        monthTotals: "Totaux du mois",
        noActivityMonth: "Aucune activité enregistrée ce mois-ci.",
        topProductsOfMonth: "Meilleurs produits du mois",
        totalsTop: (n) => `Totaux (${n} meilleurs)`,
        noTopProductsData: "Aucune donnée sur les meilleurs produits.",
        reportFooterTitle: "ElecSolution — Rapport d'inventaire du stock",
        reportFooterPage: "Généré automatiquement par le panneau d'administration",
        pickDateOrMonth: "Choisissez une date ou un mois ci-dessus, puis cliquez sur",
        addProduct: "Ajouter un produit",
        skusPill: "références",
        unitsPill: "unités",
        totalValuePill: "XAF valeur totale",
        designation: "DÉSIGNATION",
        categoryCol: "CATÉGORIE",
        entryDateCol: "DATE D'ENTRÉE",
        qty: "QTÉ",
        unitPriceCol: "PRIX UNITAIRE",
        total: "TOTAL",
        actions: "ACTIONS",
        restockTitle: "Réapprovisionner",
        editProductTitle: "Modifier le produit",
        deleteProductTitle: "Supprimer le produit",
        totalStockValue: "VALEUR TOTALE DU STOCK",
        noProductsYet: "Aucun produit en stock pour le moment. Cliquez sur",
        toCreateOne: "pour en créer un.",
        loadingStockAvailable: "Chargement du stock disponible",
        editStockEntry: "Modifier l'entrée de stock",
        addStockEntry: "Ajouter une entrée de stock",
        designationLabel: "Désignation *",
        designationPlaceholder: "ex. Boîtier papillon",
        categoryLabel: "Catégorie *",
        selectCategory: "-- Sélectionner une catégorie --",
        newCategoryOption: "+ Nouvelle catégorie…",
        newCategoryPlaceholder: "Nom de la nouvelle catégorie",
        entryDateLabel: "Date d'entrée *",
        qtyLabel: "Qté *",
        unitPriceLabel: "Prix unitaire (XAF) *",
        totalAutoLabel: "Total (auto)",
        saveChanges: "Enregistrer les modifications",
        lowStockAlert: "Alerte de stock faible",
        stock: "Stock",
        price: "Prix",
        quickRestock: "Réapprovisionnement rapide",
        restock: "Réapprovisionner",
        restockAdjustStock: "Réapprovisionner / Ajuster le stock",
        productLabel: "Produit *",
        searchProductsPlaceholder: "Rechercher des produits par nom, catégorie ou ID…",
        clear: "Effacer",
        noProductsMatch: "Aucun produit correspondant",
        stockColon: (n) => `stock : ${n}`,
        typeLabel: "Type *",
        restockAddOption: "Réapprovisionnement (ajout)",
        adjustmentOption: "Ajustement (+ ou -)",
        quantityLabel: "Quantité *",
        useNegativeToRemove: "(utilisez une valeur négative pour retirer)",
        restockQtyPlaceholder: "ex. 50",
        adjustQtyPlaceholder: "ex. -3",
        noteLabel: "Note",
        notePlaceholder: "Motif de l'ajustement (facultatif)",
        saveMovement: "Enregistrer le mouvement",
        stockSelected: (name, category, qty) => `${name} — ${category} (stock : ${qty})`,
    },
};

function InventoryDashboard({ api, user }) {
    const t = useT(T);
    const [products, setProducts] = useState([]);
    const [inventoryView, setInventoryView] = useState('daily');
    const [completeInventory, setCompleteInventory] = useState(null);
    const [showStockForm, setShowStockForm] = useState(false);
    const [editingStockProductId, setEditingStockProductId] = useState(null);
    const [stockFormData, setStockFormData] = useState({
        name: '', category: '', entry_date: new Date().toISOString().slice(0, 10), quantity: '', unit_price: ''
    });
    const [newCategoryMode, setNewCategoryMode] = useState(false);
    const [reportType, setReportType] = useState('daily');
    const [reportDate, setReportDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [reportMonth, setReportMonth] = useState(() => `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`);
    const [reportData, setReportData] = useState(null);
    const [reportLoading, setReportLoading] = useState(false);
    const [inventoryOverview, setInventoryOverview] = useState(null);
    const [dailyInventory, setDailyInventory] = useState(null);
    const [monthlyInventory, setMonthlyInventory] = useState(null);
    const today = new Date().toISOString().slice(0, 10);
    const [selectedDate, setSelectedDate] = useState(today);
    const [selectedMonth, setSelectedMonth] = useState(`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`);
    const [showAdjustForm, setShowAdjustForm] = useState(false);
    const [adjustData, setAdjustData] = useState({ product_id: '', change_type: 'restock', quantity: '', note: '' });
    const [productSearch, setProductSearch] = useState('');
    const [productSearchOpen, setProductSearchOpen] = useState(false);
    const [loading, setLoading] = useState({});

    const withLoading = (key, promise) => {
        setLoading(s => ({ ...s, [key]: true }));
        return promise.finally(() => setLoading(s => ({ ...s, [key]: false })));
    };

    const loadProducts = useCallback(() => withLoading('products', api.getProducts().then(r => setProducts(r.data)).catch(() => {})), [api]);
    const loadInventoryOverview = useCallback(() => withLoading('overview', api.getInventoryOverview().then(r => setInventoryOverview(r.data)).catch(() => {})), [api]);
    const loadDailyInventory = useCallback((date) => withLoading('daily', api.getDailyInventory(date).then(r => setDailyInventory(r.data)).catch(() => {})), [api]);
    const loadMonthlyInventory = useCallback((ym) => {
        const [year, month] = ym.split('-');
        return withLoading('monthly', api.getMonthlyInventory(Number(year), Number(month)).then(r => setMonthlyInventory(r.data)).catch(() => {}));
    }, [api]);
    const loadCompleteInventory = useCallback(() => withLoading('complete', api.getCompleteInventory().then(r => setCompleteInventory(r.data)).catch(() => {})), [api]);

    useEffect(() => {
        loadProducts();
        loadInventoryOverview();
    }, [loadProducts, loadInventoryOverview]);

    useEffect(() => {
        if (inventoryView === 'daily') loadDailyInventory(selectedDate);
        else if (inventoryView === 'monthly') loadMonthlyInventory(selectedMonth);
        else if (inventoryView === 'complete') loadCompleteInventory();
    }, [inventoryView, selectedDate, selectedMonth, loadDailyInventory, loadMonthlyInventory, loadCompleteInventory]);

    const openStockCreateForm = () => {
        setEditingStockProductId(null);
        setStockFormData({
            name: '', category: '',
            entry_date: new Date().toISOString().slice(0, 10),
            quantity: '', unit_price: ''
        });
        setNewCategoryMode(false);
        setShowStockForm(true);
    };

    const openStockEditForm = (item) => {
        setEditingStockProductId(item.id);
        const isoDate = item.entry_date ? new Date(item.entry_date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
        setStockFormData({
            name: item.name || '',
            category: item.category || '',
            entry_date: isoDate,
            quantity: item.quantity ?? '',
            unit_price: item.unit_price ?? ''
        });
        setNewCategoryMode(false);
        setShowStockForm(true);
    };

    const handleStockFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const existing = editingStockProductId ? products.find(p => p.id === editingStockProductId) : null;
            const payload = {
                name: stockFormData.name,
                category: stockFormData.category,
                price: Number(stockFormData.unit_price),
                stock_quantity: Number(stockFormData.quantity),
                entry_date: stockFormData.entry_date || null,
                description: existing?.description ?? null,
                image_url: existing?.image_url ?? null,
                cbm: existing?.cbm ?? null,
                cbm_price: existing?.cbm_price ?? null
            };
            if (editingStockProductId) {
                await api.updateProduct(editingStockProductId, payload);
            } else {
                await api.createProduct(payload);
            }
            setShowStockForm(false);
            loadProducts();
            loadCompleteInventory();
            loadInventoryOverview();
        } catch (err) {
            alert(err.response?.data?.error || t.operationFailed);
        }
    };

    const handleDeleteProduct = async (id) => {
        if (!window.confirm(t.confirmDeleteProduct)) return;
        try {
            await api.deleteProduct(id);
            loadProducts();
            loadCompleteInventory();
            loadInventoryOverview();
        } catch { alert(t.failedDeleteProduct); }
    };

    const generateReport = async () => {
        setReportLoading(true);
        setReportData(null);
        try {
            if (reportType === 'daily') {
                const r = await api.getDailyInventory(reportDate);
                setReportData({ kind: 'daily', ...r.data, generatedAt: new Date().toISOString() });
            } else {
                const [year, month] = reportMonth.split('-');
                const r = await api.getMonthlyInventory(Number(year), Number(month));
                setReportData({ kind: 'monthly', ...r.data, generatedAt: new Date().toISOString() });
            }
        } catch (err) {
            alert(err.response?.data?.error || t.failedGenerateReport);
        } finally {
            setReportLoading(false);
        }
    };

    const printReport = () => {
        window.print();
    };

    const csvEscape = (v) => {
        const s = v === null || v === undefined ? '' : String(v);
        if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
        return s;
    };

    const downloadCsv = (filename, rows) => {
        const csv = rows.map(r => r.map(csvEscape).join(',')).join('\n');
        const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(url);
    };

    const exportReportCsv = () => {
        if (!reportData) return;
        const s = reportData.summary;
        const netUnits = Number(s.unitsIn) - Number(s.unitsOut);
        const netValue = Number(s.valueIn || 0) - Number(s.valueOut || 0);
        if (reportData.kind === 'daily') {
            const rows = [
                [t.csvDailyTitle],
                [t.csvDate, reportData.date],
                [t.csvGenerated, new Date(reportData.generatedAt).toLocaleString()],
                [],
                [t.csvSummary],
                [t.csvTotalMovements, s.totalMovements],
                [t.csvUnitsIn, s.unitsIn],
                [t.csvUnitsOut, s.unitsOut],
                [t.csvNetUnits, netUnits],
                [t.csvValueIn, Number(s.valueIn || 0)],
                [t.csvValueOut, Number(s.valueOut || 0)],
                [t.csvNetValue, netValue],
                [t.csvSales, s.sales],
                [t.csvRestocks, s.restocks],
                [t.csvAdjustments, s.adjustments],
                [],
                [t.csvTopProducts],
                [t.csvNumber, t.csvProduct, t.csvUnitPrice, t.csvUnitsSold, t.csvValueSold, t.csvUnitsAdded, t.csvValueAdded],
                ...reportData.topProducts.map((p, idx) => [
                    idx + 1,
                    p.name,
                    Number(p.unit_price || 0),
                    p.units_sold || 0,
                    Number(p.value_sold || 0),
                    p.units_added || 0,
                    Number(p.value_added || 0)
                ]),
                [
                    t.csvTotals, '', '',
                    reportData.topProducts.reduce((a, p) => a + Number(p.units_sold || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.value_sold || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.units_added || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.value_added || 0), 0)
                ],
                [],
                [t.csvMovements],
                [t.csvTime, t.csvProduct, t.csvType, t.csvChange, t.csvUnitPrice, t.csvLineValue, t.csvStockAfter, t.csvNote, t.csvBy],
                ...reportData.movements.map(m => [
                    new Date(m.created_at).toLocaleTimeString(),
                    m.product_name,
                    m.change_type,
                    m.quantity,
                    Number(m.unit_price || 0),
                    (m.quantity >= 0 ? 1 : -1) * Number(m.line_value || 0),
                    m.current_stock,
                    m.note || '',
                    m.actor_name || t.system
                ])
            ];
            downloadCsv(`stock-report-daily-${reportData.date}.csv`, rows);
        } else {
            const rows = [
                [t.csvMonthlyTitle],
                [t.csvYear, reportData.year],
                [t.csvMonth, reportData.month],
                [t.csvGenerated, new Date(reportData.generatedAt).toLocaleString()],
                [],
                [t.csvSummary],
                [t.csvTotalMovements, s.totalMovements],
                [t.csvUnitsIn, s.unitsIn],
                [t.csvUnitsOut, s.unitsOut],
                [t.csvNetUnits, netUnits],
                [t.csvValueIn, Number(s.valueIn || 0)],
                [t.csvValueOut, Number(s.valueOut || 0)],
                [t.csvNetValue, netValue],
                [t.csvSales, s.sales],
                [t.csvRestocks, s.restocks],
                [t.csvAdjustments, s.adjustments],
                [],
                [t.csvDailyBreakdown],
                [t.csvDay, t.csvMovements, t.csvUnitsIn, t.csvUnitsOut, t.csvNetUnits, t.csvValueIn, t.csvValueOut, t.csvNetValue],
                ...reportData.daily.map(d => [
                    new Date(d.day).toLocaleDateString(),
                    d.movements,
                    d.unitsIn,
                    d.unitsOut,
                    Number(d.unitsIn) - Number(d.unitsOut),
                    Number(d.valueIn || 0),
                    Number(d.valueOut || 0),
                    Number(d.valueIn || 0) - Number(d.valueOut || 0)
                ]),
                [
                    t.csvMonthTotals, s.totalMovements, s.unitsIn, s.unitsOut, netUnits,
                    Number(s.valueIn || 0), Number(s.valueOut || 0), netValue
                ],
                [],
                [t.csvTopProducts],
                [t.csvNumber, t.csvProduct, t.csvCategory, t.csvUnitPrice, t.csvUnitsSold, t.csvValueSold, t.csvUnitsAdded, t.csvValueAdded],
                ...reportData.topProducts.map((p, idx) => [
                    idx + 1,
                    p.name,
                    p.category,
                    Number(p.unit_price || 0),
                    p.units_sold || 0,
                    Number(p.value_sold || 0),
                    p.units_added || 0,
                    Number(p.value_added || 0)
                ]),
                [
                    t.csvTotals, '', '', '',
                    reportData.topProducts.reduce((a, p) => a + Number(p.units_sold || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.value_sold || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.units_added || 0), 0),
                    reportData.topProducts.reduce((a, p) => a + Number(p.value_added || 0), 0)
                ]
            ];
            downloadCsv(`stock-report-monthly-${reportData.year}-${String(reportData.month).padStart(2, '0')}.csv`, rows);
        }
    };

    const handleAdjustStock = async (e) => {
        e.preventDefault();
        try {
            await api.adjustStock({
                product_id: Number(adjustData.product_id),
                change_type: adjustData.change_type,
                quantity: Number(adjustData.quantity),
                note: adjustData.note
            });
            setShowAdjustForm(false);
            setAdjustData({ product_id: '', change_type: 'restock', quantity: '', note: '' });
            setProductSearch('');
            setProductSearchOpen(false);
            loadInventoryOverview();
            if (inventoryView === 'daily') loadDailyInventory(selectedDate);
            else if (inventoryView === 'monthly') loadMonthlyInventory(selectedMonth);
            loadProducts();
        } catch (err) {
            alert(err.response?.data?.error || t.failedAdjustStock);
        }
    };

    return (
        <div className="admin-inventory">
            <div className="admin-header">
                <h1><FaWarehouse /> {t.stockInventory}</h1>
                <button className="admin-btn primary" onClick={() => setShowAdjustForm(true)}>
                    <FaPlus /> {t.restockAdjust}
                </button>
            </div>

            {loading.overview && !inventoryOverview && <Loader label={t.loadingInventory} />}

            {inventoryOverview && (
                <div className="stats-grid">
                    <div className="stat-card"><FaBox className="stat-icon" /><div><h3>{inventoryOverview.totals.totalSkus}</h3><p>{t.skus}</p></div></div>
                    <div className="stat-card"><FaWarehouse className="stat-icon" /><div><h3>{Number(inventoryOverview.totals.totalUnits).toLocaleString()}</h3><p>{t.unitsInStock}</p></div></div>
                    <div className="stat-card revenue"><FaChartLine className="stat-icon" /><div><h3>{Number(inventoryOverview.totals.inventoryValue).toLocaleString()} XAF</h3><p>{t.inventoryValue}</p></div></div>
                    <div className="stat-card pending-provider"><FaExclamationTriangle className="stat-icon" /><div><h3>{inventoryOverview.totals.lowStock}</h3><p>{t.lowStockLabel}</p></div></div>
                    <div className="stat-card pending-provider"><FaBan className="stat-icon" /><div><h3>{inventoryOverview.totals.outOfStock}</h3><p>{t.outOfStock}</p></div></div>
                </div>
            )}

            {inventoryOverview && (
                <div className="inventory-quick-totals">
                    <div className="quick-total-card today">
                        <h3><FaCalendarDay /> {t.today}</h3>
                        <div className="quick-total-row">
                            <span className="in"><FaArrowUp /> {inventoryOverview.today.unitsIn} {t.inSuffix}</span>
                            <span className="out"><FaArrowDown /> {inventoryOverview.today.unitsOut} {t.outSuffix}</span>
                            <span className="movements">{inventoryOverview.today.movements} {t.movements}</span>
                        </div>
                    </div>
                    <div className="quick-total-card month">
                        <h3><FaCalendarAlt /> {t.thisMonth}</h3>
                        <div className="quick-total-row">
                            <span className="in"><FaArrowUp /> {inventoryOverview.month.unitsIn} {t.inSuffix}</span>
                            <span className="out"><FaArrowDown /> {inventoryOverview.month.unitsOut} {t.outSuffix}</span>
                            <span className="movements">{inventoryOverview.month.movements} {t.movements}</span>
                        </div>
                    </div>
                </div>
            )}

            <div className="inventory-tabs">
                <button className={`inventory-tab-btn ${inventoryView === 'daily' ? 'active' : ''}`} onClick={() => setInventoryView('daily')}>
                    <FaCalendarDay /> {t.dailyActivity}
                </button>
                <button className={`inventory-tab-btn ${inventoryView === 'monthly' ? 'active' : ''}`} onClick={() => setInventoryView('monthly')}>
                    <FaCalendarAlt /> {t.monthlyActivity}
                </button>
                <button className={`inventory-tab-btn ${inventoryView === 'reports' ? 'active' : ''}`} onClick={() => setInventoryView('reports')}>
                    <FaFileAlt /> {t.reports}
                </button>
                <button className={`inventory-tab-btn ${inventoryView === 'complete' ? 'active' : ''}`} onClick={() => setInventoryView('complete')}>
                    <FaBox /> {t.stockAvailable}
                </button>
            </div>

            {inventoryView === 'daily' && dailyInventory && (
                <div className="inventory-section">
                    <div className="inventory-controls">
                        <label>{t.dateLabel}</label>
                        <input type="date" value={selectedDate} max={today} onChange={e => setSelectedDate(e.target.value)} />
                    </div>

                    <div className="inventory-summary-row">
                        <div className="summary-pill"><strong>{dailyInventory.summary.totalMovements}</strong> {t.movements}</div>
                        <div className="summary-pill in"><FaArrowUp /> <strong>{dailyInventory.summary.unitsIn}</strong> {t.unitsInPill}</div>
                        <div className="summary-pill out"><FaArrowDown /> <strong>{dailyInventory.summary.unitsOut}</strong> {t.unitsOutPill}</div>
                        <div className="summary-pill"><strong>{dailyInventory.summary.sales}</strong> {t.salesPill}</div>
                        <div className="summary-pill"><strong>{dailyInventory.summary.restocks}</strong> {t.restocksPill}</div>
                        <div className="summary-pill"><strong>{dailyInventory.summary.adjustments}</strong> {t.adjustmentsPill}</div>
                    </div>

                    {dailyInventory.topProducts.length > 0 && (
                        <>
                            <h2>{t.topProductsOn(dailyInventory.date)}</h2>
                            <table className="admin-table">
                                <thead><tr><th>{t.product}</th><th>{t.unitsSold}</th><th>{t.unitsAdded}</th></tr></thead>
                                <tbody>
                                    {dailyInventory.topProducts.map(p => (
                                        <tr key={p.id}>
                                            <td>{p.name}</td>
                                            <td className="out-cell">{p.units_sold || 0}</td>
                                            <td className="in-cell">{p.units_added || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}

                    <h2>{t.allMovements}</h2>
                    <table className="admin-table">
                        <thead><tr><th>{t.time}</th><th>{t.product}</th><th>{t.type}</th><th>{t.change}</th><th>{t.currentStock}</th><th>{t.note}</th><th>{t.by}</th></tr></thead>
                        <tbody>
                            {dailyInventory.movements.map(m => (
                                <tr key={m.id}>
                                    <td>{new Date(m.created_at).toLocaleTimeString()}</td>
                                    <td>{m.product_name}</td>
                                    <td><span className={`move-type ${m.change_type}`}>{m.change_type}</span></td>
                                    <td className={m.quantity >= 0 ? 'in-cell' : 'out-cell'}>
                                        {m.quantity >= 0 ? '+' : ''}{m.quantity}
                                    </td>
                                    <td>{m.current_stock}</td>
                                    <td>{m.note || '-'}</td>
                                    <td>{m.actor_name || t.system}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    {dailyInventory.movements.length === 0 && <p className="empty-state">{t.noStockActivityDay}</p>}
                </div>
            )}

            {inventoryView === 'monthly' && monthlyInventory && (
                <div className="inventory-section">
                    <div className="inventory-controls">
                        <label>{t.monthLabel}</label>
                        <input type="month" value={selectedMonth} max={`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`} onChange={e => setSelectedMonth(e.target.value)} />
                    </div>

                    <div className="inventory-summary-row">
                        <div className="summary-pill"><strong>{monthlyInventory.summary.totalMovements}</strong> {t.movements}</div>
                        <div className="summary-pill in"><FaArrowUp /> <strong>{monthlyInventory.summary.unitsIn}</strong> {t.unitsInPill}</div>
                        <div className="summary-pill out"><FaArrowDown /> <strong>{monthlyInventory.summary.unitsOut}</strong> {t.unitsOutPill}</div>
                        <div className="summary-pill"><strong>{monthlyInventory.summary.sales}</strong> {t.salesPill}</div>
                        <div className="summary-pill"><strong>{monthlyInventory.summary.restocks}</strong> {t.restocksPill}</div>
                        <div className="summary-pill"><strong>{monthlyInventory.summary.adjustments}</strong> {t.adjustmentsPill}</div>
                    </div>

                    <h2>{t.dailyBreakdown}</h2>
                    <table className="admin-table">
                        <thead><tr><th>{t.day}</th><th>{t.movementsCol}</th><th>{t.unitsInCol}</th><th>{t.unitsOutCol}</th><th>{t.net}</th></tr></thead>
                        <tbody>
                            {monthlyInventory.daily.map(d => {
                                const net = Number(d.unitsIn) - Number(d.unitsOut);
                                return (
                                    <tr key={d.day}>
                                        <td>{new Date(d.day).toLocaleDateString()}</td>
                                        <td>{d.movements}</td>
                                        <td className="in-cell">+{d.unitsIn}</td>
                                        <td className="out-cell">-{d.unitsOut}</td>
                                        <td className={net >= 0 ? 'in-cell' : 'out-cell'}>{net >= 0 ? '+' : ''}{net}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    {monthlyInventory.daily.length === 0 && <p className="empty-state">{t.noStockActivityMonth}</p>}

                    {monthlyInventory.topProducts.length > 0 && (
                        <>
                            <h2>{t.topProductsThisMonth}</h2>
                            <table className="admin-table">
                                <thead><tr><th>{t.product}</th><th>{t.category}</th><th>{t.unitsSold}</th><th>{t.unitsAdded}</th></tr></thead>
                                <tbody>
                                    {monthlyInventory.topProducts.map(p => (
                                        <tr key={p.id}>
                                            <td>{p.name}</td>
                                            <td><span className="category-tag">{p.category}</span></td>
                                            <td className="out-cell">{p.units_sold || 0}</td>
                                            <td className="in-cell">{p.units_added || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}
                </div>
            )}

            {inventoryView === 'reports' && (
                <div className="inventory-section reports-section">
                    <div className="report-controls no-print">
                        <div className="report-type-toggle">
                            <button className={`report-type-btn ${reportType === 'daily' ? 'active' : ''}`} onClick={() => { setReportType('daily'); setReportData(null); }}>
                                <FaCalendarDay /> {t.dailyReport}
                            </button>
                            <button className={`report-type-btn ${reportType === 'monthly' ? 'active' : ''}`} onClick={() => { setReportType('monthly'); setReportData(null); }}>
                                <FaCalendarAlt /> {t.monthlyReport}
                            </button>
                        </div>

                        <div className="report-picker">
                            {reportType === 'daily' ? (
                                <>
                                    <label>{t.dateLabel}</label>
                                    <input type="date" value={reportDate} max={today} onChange={e => setReportDate(e.target.value)} />
                                </>
                            ) : (
                                <>
                                    <label>{t.monthLabel}</label>
                                    <input type="month" value={reportMonth} max={`${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`} onChange={e => setReportMonth(e.target.value)} />
                                </>
                            )}
                            <button className="admin-btn primary" onClick={generateReport} disabled={reportLoading}>
                                {reportLoading
                                    ? <Loader inline label={t.generating} />
                                    : <><FaFileAlt /> {t.generateReport}</>}
                            </button>
                        </div>

                        {reportData && (
                            <div className="report-actions">
                                <button className="admin-btn edit" onClick={printReport}><FaPrint /> {t.print}</button>
                                <button className="admin-btn edit" onClick={exportReportCsv}><FaDownload /> {t.downloadCsv}</button>
                            </div>
                        )}
                    </div>

                    {reportData && (
                        <div className="report-document">
                            <div className="report-header">
                                <div>
                                    <h1 className="report-brand">ElecSolution</h1>
                                    <p className="report-subtitle">{reportData.kind === 'daily' ? t.reportSubtitleDaily : t.reportSubtitleMonthly}</p>
                                </div>
                                <div className="report-meta">
                                    {reportData.kind === 'daily' ? (
                                        <p><strong>{t.dateColon}</strong> {new Date(reportData.date).toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
                                    ) : (
                                        <p><strong>{t.periodColon}</strong> {new Date(reportData.year, reportData.month - 1).toLocaleDateString(undefined, { year: 'numeric', month: 'long' })}</p>
                                    )}
                                    <p><strong>{t.generatedColon}</strong> {new Date(reportData.generatedAt).toLocaleString()}</p>
                                    {user && <p><strong>{t.byColon}</strong> {user.name} ({user.email})</p>}
                                </div>
                            </div>

                            <div className="report-summary-grid">
                                <div className="report-summary-card">
                                    <span className="label">{t.totalMovements}</span>
                                    <span className="value">{reportData.summary.totalMovements}</span>
                                </div>
                                <div className="report-summary-card in">
                                    <span className="label">{t.unitsIn}</span>
                                    <span className="value">+{reportData.summary.unitsIn}</span>
                                </div>
                                <div className="report-summary-card out">
                                    <span className="label">{t.unitsOut}</span>
                                    <span className="value">-{reportData.summary.unitsOut}</span>
                                </div>
                                <div className="report-summary-card">
                                    <span className="label">{t.sales}</span>
                                    <span className="value">{reportData.summary.sales}</span>
                                </div>
                                <div className="report-summary-card">
                                    <span className="label">{t.restocks}</span>
                                    <span className="value">{reportData.summary.restocks}</span>
                                </div>
                                <div className="report-summary-card">
                                    <span className="label">{t.adjustments}</span>
                                    <span className="value">{reportData.summary.adjustments}</span>
                                </div>
                                <div className="report-summary-card net">
                                    <span className="label">{t.netUnits}</span>
                                    <span className="value">{(Number(reportData.summary.unitsIn) - Number(reportData.summary.unitsOut)) >= 0 ? '+' : ''}{Number(reportData.summary.unitsIn) - Number(reportData.summary.unitsOut)}</span>
                                </div>
                                <div className="report-summary-card in">
                                    <span className="label">{t.valueIn}</span>
                                    <span className="value">+{Number(reportData.summary.valueIn || 0).toLocaleString()} XAF</span>
                                </div>
                                <div className="report-summary-card out">
                                    <span className="label">{t.valueOutSales}</span>
                                    <span className="value">{Number(reportData.summary.valueOut || 0).toLocaleString()} XAF</span>
                                </div>
                                <div className="report-summary-card net">
                                    <span className="label">{t.netValue}</span>
                                    <span className="value">{(Number(reportData.summary.valueIn || 0) - Number(reportData.summary.valueOut || 0)).toLocaleString()} XAF</span>
                                </div>
                            </div>

                            {reportData.kind === 'daily' && (
                                <>
                                    <h2 className="report-section-title">{t.topProductsOfDay}</h2>
                                    {reportData.topProducts.length > 0 ? (
                                        <table className="report-table">
                                            <thead><tr><th>#</th><th>{t.product}</th><th>{t.unitPrice}</th><th>{t.unitsSold}</th><th>{t.valueSold}</th><th>{t.unitsAdded}</th><th>{t.valueAdded}</th></tr></thead>
                                            <tbody>
                                                {reportData.topProducts.map((p, idx) => (
                                                    <tr key={p.id}>
                                                        <td>{idx + 1}</td>
                                                        <td>{p.name}</td>
                                                        <td>{Number(p.unit_price || 0).toLocaleString()} XAF</td>
                                                        <td className="out-cell">{p.units_sold || 0}</td>
                                                        <td className="out-cell">{Number(p.value_sold || 0).toLocaleString()} XAF</td>
                                                        <td className="in-cell">{p.units_added || 0}</td>
                                                        <td className="in-cell">{Number(p.value_added || 0).toLocaleString()} XAF</td>
                                                    </tr>
                                                ))}
                                                <tr className="report-totals-row">
                                                    <td colSpan="3"><strong>{t.totals}</strong></td>
                                                    <td className="out-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.units_sold || 0), 0)}</strong></td>
                                                    <td className="out-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.value_sold || 0), 0).toLocaleString()} XAF</strong></td>
                                                    <td className="in-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.units_added || 0), 0)}</strong></td>
                                                    <td className="in-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.value_added || 0), 0).toLocaleString()} XAF</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : <p className="empty-state">{t.noProductActivityDate}</p>}

                                    <h2 className="report-section-title">{t.allStockMovements}</h2>
                                    {reportData.movements.length > 0 ? (
                                        <table className="report-table">
                                            <thead><tr><th>{t.time}</th><th>{t.product}</th><th>{t.type}</th><th>{t.change}</th><th>{t.unitPrice}</th><th>{t.lineValue}</th><th>{t.stockAfter}</th><th>{t.note}</th><th>{t.by}</th></tr></thead>
                                            <tbody>
                                                {reportData.movements.map(m => (
                                                    <tr key={m.id}>
                                                        <td>{new Date(m.created_at).toLocaleTimeString()}</td>
                                                        <td>{m.product_name}</td>
                                                        <td><span className={`move-type ${m.change_type}`}>{m.change_type}</span></td>
                                                        <td className={m.quantity >= 0 ? 'in-cell' : 'out-cell'}>{m.quantity >= 0 ? '+' : ''}{m.quantity}</td>
                                                        <td>{Number(m.unit_price || 0).toLocaleString()} XAF</td>
                                                        <td className={m.quantity >= 0 ? 'in-cell' : 'out-cell'}>
                                                            {m.quantity >= 0 ? '+' : '-'}{Number(m.line_value || 0).toLocaleString()} XAF
                                                        </td>
                                                        <td>{m.current_stock}</td>
                                                        <td>{m.note || '-'}</td>
                                                        <td>{m.actor_name || t.system}</td>
                                                    </tr>
                                                ))}
                                                <tr className="report-totals-row">
                                                    <td colSpan="3"><strong>{t.dayTotals}</strong></td>
                                                    <td>
                                                        <strong className="in-cell">+{reportData.summary.unitsIn}</strong> /
                                                        <strong className="out-cell"> -{reportData.summary.unitsOut}</strong>
                                                    </td>
                                                    <td>-</td>
                                                    <td>
                                                        <strong className="in-cell">+{Number(reportData.summary.valueIn || 0).toLocaleString()}</strong> /
                                                        <strong className="out-cell"> -{Number(reportData.summary.valueOut || 0).toLocaleString()} XAF</strong>
                                                    </td>
                                                    <td colSpan="3"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : <p className="empty-state">{t.noMovementsDate}</p>}
                                </>
                            )}

                            {reportData.kind === 'monthly' && (
                                <>
                                    <h2 className="report-section-title">{t.dailyBreakdown}</h2>
                                    {reportData.daily.length > 0 ? (
                                        <table className="report-table">
                                            <thead><tr><th>{t.day}</th><th>{t.movementsCol}</th><th>{t.unitsInCol}</th><th>{t.unitsOutCol}</th><th>{t.netUnitsCol}</th><th>{t.valueInCol}</th><th>{t.valueOutCol}</th><th>{t.netValueCol}</th></tr></thead>
                                            <tbody>
                                                {reportData.daily.map(d => {
                                                    const net = Number(d.unitsIn) - Number(d.unitsOut);
                                                    const netVal = Number(d.valueIn || 0) - Number(d.valueOut || 0);
                                                    return (
                                                        <tr key={d.day}>
                                                            <td>{new Date(d.day).toLocaleDateString()}</td>
                                                            <td>{d.movements}</td>
                                                            <td className="in-cell">+{d.unitsIn}</td>
                                                            <td className="out-cell">-{d.unitsOut}</td>
                                                            <td className={net >= 0 ? 'in-cell' : 'out-cell'}>{net >= 0 ? '+' : ''}{net}</td>
                                                            <td className="in-cell">+{Number(d.valueIn || 0).toLocaleString()} XAF</td>
                                                            <td className="out-cell">-{Number(d.valueOut || 0).toLocaleString()} XAF</td>
                                                            <td className={netVal >= 0 ? 'in-cell' : 'out-cell'}>{netVal >= 0 ? '+' : ''}{netVal.toLocaleString()} XAF</td>
                                                        </tr>
                                                    );
                                                })}
                                                <tr className="report-totals-row">
                                                    <td><strong>{t.monthTotals}</strong></td>
                                                    <td><strong>{reportData.summary.totalMovements}</strong></td>
                                                    <td className="in-cell"><strong>+{reportData.summary.unitsIn}</strong></td>
                                                    <td className="out-cell"><strong>-{reportData.summary.unitsOut}</strong></td>
                                                    <td><strong>{(Number(reportData.summary.unitsIn) - Number(reportData.summary.unitsOut)) >= 0 ? '+' : ''}{Number(reportData.summary.unitsIn) - Number(reportData.summary.unitsOut)}</strong></td>
                                                    <td className="in-cell"><strong>+{Number(reportData.summary.valueIn || 0).toLocaleString()} XAF</strong></td>
                                                    <td className="out-cell"><strong>-{Number(reportData.summary.valueOut || 0).toLocaleString()} XAF</strong></td>
                                                    <td><strong>{(Number(reportData.summary.valueIn || 0) - Number(reportData.summary.valueOut || 0)).toLocaleString()} XAF</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : <p className="empty-state">{t.noActivityMonth}</p>}

                                    <h2 className="report-section-title">{t.topProductsOfMonth}</h2>
                                    {reportData.topProducts.length > 0 ? (
                                        <table className="report-table">
                                            <thead><tr><th>#</th><th>{t.product}</th><th>{t.category}</th><th>{t.unitPrice}</th><th>{t.unitsSold}</th><th>{t.valueSold}</th><th>{t.unitsAdded}</th><th>{t.valueAdded}</th></tr></thead>
                                            <tbody>
                                                {reportData.topProducts.map((p, idx) => (
                                                    <tr key={p.id}>
                                                        <td>{idx + 1}</td>
                                                        <td>{p.name}</td>
                                                        <td><span className="category-tag">{p.category}</span></td>
                                                        <td>{Number(p.unit_price || 0).toLocaleString()} XAF</td>
                                                        <td className="out-cell">{p.units_sold || 0}</td>
                                                        <td className="out-cell">{Number(p.value_sold || 0).toLocaleString()} XAF</td>
                                                        <td className="in-cell">{p.units_added || 0}</td>
                                                        <td className="in-cell">{Number(p.value_added || 0).toLocaleString()} XAF</td>
                                                    </tr>
                                                ))}
                                                <tr className="report-totals-row">
                                                    <td colSpan="4"><strong>{t.totalsTop(reportData.topProducts.length)}</strong></td>
                                                    <td className="out-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.units_sold || 0), 0)}</strong></td>
                                                    <td className="out-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.value_sold || 0), 0).toLocaleString()} XAF</strong></td>
                                                    <td className="in-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.units_added || 0), 0)}</strong></td>
                                                    <td className="in-cell"><strong>{reportData.topProducts.reduce((s, p) => s + Number(p.value_added || 0), 0).toLocaleString()} XAF</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    ) : <p className="empty-state">{t.noTopProductsData}</p>}
                                </>
                            )}

                            <div className="report-footer">
                                <p>{t.reportFooterTitle}</p>
                                <p className="report-page">{t.reportFooterPage}</p>
                            </div>
                        </div>
                    )}

                    {reportLoading && <Loader label={t.generatingReport} />}
                    {!reportData && !reportLoading && (
                        <p className="empty-state">{t.pickDateOrMonth} <strong>{t.generateReport}</strong>.</p>
                    )}
                </div>
            )}

            {inventoryView === 'complete' && completeInventory && (() => {
                const allItems = completeInventory.categories.flatMap(c =>
                    c.items.map(it => ({ ...it, category: c.category }))
                );
                return (
                    <div className="inventory-section">
                        <div className="admin-header" style={{ marginBottom: 12 }}>
                            <h2 style={{ margin: 0 }}>{t.stockAvailable}</h2>
                            <button className="admin-btn primary" onClick={openStockCreateForm}>
                                <FaPlus /> {t.addProduct}
                            </button>
                        </div>

                        <div className="inventory-summary-row">
                            <div className="summary-pill"><strong>{completeInventory.totals.skus}</strong> {t.skusPill}</div>
                            <div className="summary-pill in"><strong>{Number(completeInventory.totals.units).toLocaleString()}</strong> {t.unitsPill}</div>
                            <div className="summary-pill"><strong>{Number(completeInventory.totals.value).toLocaleString()}</strong> {t.totalValuePill}</div>
                        </div>

                        {allItems.length > 0 ? (
                            <table className="admin-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>{t.designation}</th>
                                        <th>{t.categoryCol}</th>
                                        <th>{t.entryDateCol}</th>
                                        <th>{t.qty}</th>
                                        <th>{t.unitPriceCol}</th>
                                        <th>{t.total}</th>
                                        <th>{t.actions}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allItems.map((it, idx) => (
                                        <tr key={it.id}>
                                            <td>{idx + 1}</td>
                                            <td>{it.name}</td>
                                            <td><span className="category-tag">{it.category}</span></td>
                                            <td>{it.entry_date ? new Date(it.entry_date).toLocaleDateString() : '-'}</td>
                                            <td className={it.quantity === 0 ? 'low-stock' : ''}>{Number(it.quantity).toLocaleString()}</td>
                                            <td>{Number(it.unit_price).toLocaleString()} XAF</td>
                                            <td>{Number(it.line_total).toLocaleString()} XAF</td>
                                            <td>
                                                <button
                                                    className="admin-btn small edit"
                                                    title={t.restockTitle}
                                                    onClick={() => {
                                                        setAdjustData({ product_id: String(it.id), change_type: 'restock', quantity: '', note: '' });
                                                        setProductSearch(t.stockSelected(it.name, it.category, it.quantity));
                                                        setProductSearchOpen(false);
                                                        setShowAdjustForm(true);
                                                    }}
                                                >
                                                    <FaPlus />
                                                </button>
                                                <button
                                                    className="admin-btn small edit"
                                                    title={t.editProductTitle}
                                                    onClick={() => openStockEditForm(it)}
                                                >
                                                    <FaEdit />
                                                </button>
                                                <button
                                                    className="admin-btn small danger"
                                                    title={t.deleteProductTitle}
                                                    onClick={() => handleDeleteProduct(it.id)}
                                                >
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr className="report-totals-row">
                                        <td colSpan="4"><strong>{t.totalStockValue}</strong></td>
                                        <td><strong>{Number(completeInventory.totals.units).toLocaleString()}</strong></td>
                                        <td></td>
                                        <td><strong>{Number(completeInventory.totals.value).toLocaleString()} XAF</strong></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <p className="empty-state">{t.noProductsYet} <strong>{t.addProduct}</strong> {t.toCreateOne}</p>
                        )}
                    </div>
                );
            })()}

            {inventoryView === 'complete' && !completeInventory && (
                <div className="inventory-section">
                    <Loader label={t.loadingStockAvailable} />
                </div>
            )}

            {showStockForm && (
                <div className="modal-overlay" onClick={() => setShowStockForm(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{editingStockProductId ? t.editStockEntry : t.addStockEntry}</h2>
                            <button className="modal-close" onClick={() => setShowStockForm(false)}><FaTimes /></button>
                        </div>
                        <form onSubmit={handleStockFormSubmit} className="product-form">
                            <div className="form-row">
                                <div className="form-group">
                                    <label>{t.designationLabel}</label>
                                    <input
                                        type="text"
                                        value={stockFormData.name}
                                        onChange={e => setStockFormData({ ...stockFormData, name: e.target.value })}
                                        required
                                        placeholder={t.designationPlaceholder}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{t.categoryLabel}</label>
                                    {(() => {
                                        const knownCategories = [...new Set(
                                            (completeInventory?.categories || []).map(c => c.category).filter(Boolean)
                                        )].sort();
                                        return (
                                            <>
                                                <select
                                                    value={newCategoryMode ? '__new__' : stockFormData.category}
                                                    onChange={e => {
                                                        if (e.target.value === '__new__') {
                                                            setNewCategoryMode(true);
                                                            setStockFormData({ ...stockFormData, category: '' });
                                                        } else {
                                                            setNewCategoryMode(false);
                                                            setStockFormData({ ...stockFormData, category: e.target.value });
                                                        }
                                                    }}
                                                    required={!newCategoryMode}
                                                >
                                                    <option value="">{t.selectCategory}</option>
                                                    {knownCategories.map(c => (
                                                        <option key={c} value={c}>{c}</option>
                                                    ))}
                                                    <option value="__new__">{t.newCategoryOption}</option>
                                                </select>
                                                {newCategoryMode && (
                                                    <input
                                                        type="text"
                                                        style={{ marginTop: 8 }}
                                                        value={stockFormData.category}
                                                        onChange={e => setStockFormData({ ...stockFormData, category: e.target.value })}
                                                        required
                                                        placeholder={t.newCategoryPlaceholder}
                                                        autoFocus
                                                    />
                                                )}
                                            </>
                                        );
                                    })()}
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>{t.entryDateLabel}</label>
                                    <input
                                        type="date"
                                        value={stockFormData.entry_date}
                                        onChange={e => setStockFormData({ ...stockFormData, entry_date: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{t.qtyLabel}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={stockFormData.quantity}
                                        onChange={e => setStockFormData({ ...stockFormData, quantity: e.target.value })}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>{t.unitPriceLabel}</label>
                                    <input
                                        type="number"
                                        min="0"
                                        value={stockFormData.unit_price}
                                        onChange={e => setStockFormData({ ...stockFormData, unit_price: e.target.value })}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>{t.totalAutoLabel}</label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={`${((Number(stockFormData.quantity) || 0) * (Number(stockFormData.unit_price) || 0)).toLocaleString()} XAF`}
                                    />
                                </div>
                            </div>
                            <button type="submit" className="admin-btn primary full-width">
                                <FaSave /> {editingStockProductId ? t.saveChanges : t.addProduct}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            {inventoryOverview && inventoryOverview.lowStockItems.length > 0 && (
                <div className="inventory-section">
                    <h2><FaExclamationTriangle /> {t.lowStockAlert}</h2>
                    <table className="admin-table">
                        <thead><tr><th>{t.product}</th><th>{t.category}</th><th>{t.stock}</th><th>{t.price}</th><th>{t.quickRestock}</th></tr></thead>
                        <tbody>
                            {inventoryOverview.lowStockItems.map(p => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td><span className="category-tag">{p.category}</span></td>
                                    <td className={p.stock_quantity === 0 ? 'low-stock' : ''}>{p.stock_quantity}</td>
                                    <td>{Number(p.price).toLocaleString()} XAF</td>
                                    <td>
                                        <button className="admin-btn small edit" onClick={() => {
                                            setAdjustData({ product_id: String(p.id), change_type: 'restock', quantity: '', note: '' });
                                            setProductSearch(t.stockSelected(p.name, p.category, p.stock_quantity));
                                            setProductSearchOpen(false);
                                            setShowAdjustForm(true);
                                        }}>
                                            <FaPlus /> {t.restock}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showAdjustForm && (
                <div className="modal-overlay" onClick={() => setShowAdjustForm(false)}>
                    <div className="modal" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{t.restockAdjustStock}</h2>
                            <button className="modal-close" onClick={() => setShowAdjustForm(false)}><FaTimes /></button>
                        </div>
                        <form onSubmit={handleAdjustStock} className="product-form">
                            <div className="form-group">
                                <label>{t.productLabel}</label>
                                <div className="search-select">
                                    <input
                                        type="text"
                                        className="search-select-input"
                                        placeholder={t.searchProductsPlaceholder}
                                        value={productSearch}
                                        onChange={e => {
                                            setProductSearch(e.target.value);
                                            setProductSearchOpen(true);
                                            if (adjustData.product_id) setAdjustData({ ...adjustData, product_id: '' });
                                        }}
                                        onFocus={() => setProductSearchOpen(true)}
                                        autoComplete="off"
                                    />
                                    {adjustData.product_id && !productSearchOpen && (
                                        <button type="button" className="search-select-clear" onClick={() => { setAdjustData({ ...adjustData, product_id: '' }); setProductSearch(''); setProductSearchOpen(true); }} title={t.clear}>
                                            <FaTimes />
                                        </button>
                                    )}
                                    {productSearchOpen && (
                                        <ul className="search-select-options">
                                            {(() => {
                                                const q = productSearch.trim().toLowerCase();
                                                const filtered = products.filter(p =>
                                                    !q ||
                                                    p.name.toLowerCase().includes(q) ||
                                                    (p.category || '').toLowerCase().includes(q) ||
                                                    String(p.id) === q
                                                ).slice(0, 50);
                                                if (filtered.length === 0) {
                                                    return <li className="search-select-empty">{t.noProductsMatch}</li>;
                                                }
                                                return filtered.map(p => (
                                                    <li
                                                        key={p.id}
                                                        className={`search-select-option ${adjustData.product_id === String(p.id) ? 'selected' : ''}`}
                                                        onClick={() => {
                                                            setAdjustData({ ...adjustData, product_id: String(p.id) });
                                                            setProductSearch(t.stockSelected(p.name, p.category, p.stock_quantity));
                                                            setProductSearchOpen(false);
                                                        }}
                                                    >
                                                        <span className="opt-name">{p.name}</span>
                                                        <span className="opt-meta">
                                                            <span className="category-tag">{p.category}</span>
                                                            <span className={p.stock_quantity < 10 ? 'opt-stock low' : 'opt-stock'}>{t.stockColon(p.stock_quantity)}</span>
                                                            <span className="opt-price">{Number(p.price).toLocaleString()} XAF</span>
                                                        </span>
                                                    </li>
                                                ));
                                            })()}
                                        </ul>
                                    )}
                                </div>
                                <input type="hidden" required value={adjustData.product_id} readOnly />
                            </div>
                            <div className="form-row">
                                <div className="form-group">
                                    <label>{t.typeLabel}</label>
                                    <select value={adjustData.change_type} onChange={e => setAdjustData({ ...adjustData, change_type: e.target.value })}>
                                        <option value="restock">{t.restockAddOption}</option>
                                        <option value="adjustment">{t.adjustmentOption}</option>
                                    </select>
                                </div>
                                <div className="form-group">
                                    <label>{t.quantityLabel} {adjustData.change_type === 'adjustment' && <small>{t.useNegativeToRemove}</small>}</label>
                                    <input type="number" value={adjustData.quantity} onChange={e => setAdjustData({ ...adjustData, quantity: e.target.value })} required placeholder={adjustData.change_type === 'restock' ? t.restockQtyPlaceholder : t.adjustQtyPlaceholder} />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>{t.noteLabel}</label>
                                <input type="text" value={adjustData.note} onChange={e => setAdjustData({ ...adjustData, note: e.target.value })} placeholder={t.notePlaceholder} />
                            </div>
                            <button type="submit" className="admin-btn primary full-width">
                                <FaSave /> {t.saveMovement}
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default InventoryDashboard;
